import { cva } from 'class-variance-authority'

import { ATTACHED_UNSELECTED } from '@/components/lemmala-design-system/table/consts'

/** Surface shared by the table's loading and empty placeholders. */
export const tablePlaceholderVariants = cva(
  'relative min-h-96 w-full rounded-lg bg-main-background-card',
  {
    variants: {
      borderless: {
        true: '',
        false: 'border border-main-border-default',
      },
    },
    defaultVariants: {
      borderless: false,
    },
  },
)

export const filterTriggerVariants = cva(
  'box-border flex items-center justify-center !text-label-default focus:outline-none',
  {
    variants: {
      state: {
        unselected:
          'gap-1.5 rounded px-2 py-1 text-main-foreground-primary hover:bg-main-background-interactive-list-hover',
        selected:
          'gap-2 !rounded-none !rounded-l bg-main-background-interactive-list-selected px-2 py-1 text-main-foreground-accent hover:bg-main-background-interactive-list-selectedHover',
      },
      /** True when a remove button is joined to the trigger's right edge. */
      attached: {
        true: 'rounded-r-none',
        false: '',
      },
      /** True when no clear button is joined on, so a selected chip rounds its own right edge. */
      standalone: {
        true: '',
        false: '',
      },
    },
    compoundVariants: [
      { state: 'unselected', attached: true, className: ATTACHED_UNSELECTED },
      { state: 'selected', standalone: true, className: '!rounded-r' },
    ],
    defaultVariants: {
      state: 'unselected',
      attached: false,
      standalone: false,
    },
  },
)

export const filterRemoveButtonVariants = cva('rounded-l-none', {
  variants: {
    state: {
      unselected: ATTACHED_UNSELECTED,
      selected:
        'bg-main-background-interactive-list-selected text-main-foreground-accent hover:bg-main-background-interactive-list-selectedHover',
    },
  },
  defaultVariants: {
    state: 'unselected',
  },
})

export const clearButtonVariants = cva('w-full justify-start', {
  variants: {
    active: {
      true: 'text-main-foreground-accent',
      false: '',
    },
  },
  defaultVariants: {
    active: false,
  },
})
